module.exports = __webpack_public_path__ + "static/media/lutheri.0a6d915e.svg";